import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {NavLink, useNavigate} from 'react-router-dom';

const ManagerLinks = () => {
  const navigate = useNavigate();
  const {user} = useGlobalState((state) => state.app);

  let hasPubs = false;

  if (user?.attributes) {
    hasPubs = user.attributes.pubs.length > 0;
  }

  const getLinkClass = () => (hasPubs ? 'sidebar__link' : 'sidebar__link sidebar__link--disabled');

  return (
    <>
      <Button className="sidebar__button sidebar__new-post" onClick={() => navigate(Routes.POST_GENERATOR)}>
        <Icon icon="plus-circle-bold" />
        New Post
      </Button>
      <NavLink
        to={Routes.HOME}
        className={({isActive}) => (isActive ? `${getLinkClass()} sidebar__link--active` : `${getLinkClass()}`)}
      >
        <Icon icon="dashboard" />
        Dashboard
      </NavLink>
      <NavLink
        to={Routes.BEERS_MANAGER}
        className={({isActive}) => (isActive ? `${getLinkClass()} sidebar__link--active` : `${getLinkClass()}`)}
      >
        <Icon icon="beers-2" />
        Beers on Tap
      </NavLink>
      <NavLink
        to={Routes.POST_ARCHIVE}
        className={({isActive}) => (isActive ? `${getLinkClass()} sidebar__link--active` : `${getLinkClass()}`)}
      >
        <Icon icon="post-archives" />
        Post Archive
      </NavLink>
      <NavLink
        to={Routes.PUB_PAGE}
        className={({isActive}) => (isActive ? `${getLinkClass()} sidebar__link--active` : `${getLinkClass()}`)}
      >
        <Icon icon="pubs" />
        Pub Page
      </NavLink>
    </>
  );
};

export default ManagerLinks;
